module.exports = __webpack_public_path__ + "static/media/virual_games_mob.2296fb9d.jpeg";